import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { ITipsByDay, TipsByDay } from '../../../../model/tips-by-day';
import { ITipsByDayApiService } from './tips-by-day-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportTipsByDayQueryDto } from './dtos/export-tips-by-day.query.dto';
import { FindTipsByDayQueryDto } from './dtos/find-tips-by-day.query.dto';
import { FindTipsByDayResponseDto } from './dtos/find-tips-by-day.response.dto';

@Injectable({
  providedIn: 'root',
})
export class TipsByDayMockApiService implements ITipsByDayApiService {
  data = {
    tips_by_days: {
      items: [] as TipsByDay[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<ITipsByDay>,
      subject: new BehaviorSubject<Maybe<TipsByDay[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get tipsByDaysData() {
    return this.data['tips_by_days'] as Data<TipsByDay, ITipsByDay>;
  }

  findTipsByDay(query: FindTipsByDayQueryDto): Promise<FindTipsByDayResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportTipsByDay(query: ExportTipsByDayQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
